/**
 * Since we need to flatten our inputs in our data layer to ensure that
 * validation works out of the box, then we need to expand our content again
 * into rows with relevant inputs.
 */
function transformContentToRows(content) {
  return content.reduce((acc, curr) => {
    acc[curr.meta.rowIndex] ??= [];
    acc[curr.meta.rowIndex]?.push(curr);
    return acc;
  }, []);
}

export { transformContentToRows };
//# sourceMappingURL=util.transform-content-to-rows.js.map
